import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { IDropdownMenuItem } from './DropdownMenu.interface';
import './DropdownMenu.scss';

export interface IDropdownMenuProps {
  items: IDropdownMenuItem[];
}

export const DropdownMenu = ({ items }: React.PropsWithChildren<IDropdownMenuProps>): JSX.Element => {
  const renderItems = () =>
    items.map((item, i) => (
      <Dropdown.Item onClick={item.clickHandler} key={i}>
        {item.title}
      </Dropdown.Item>
    ));

  return (
    <Dropdown className="widget-dd">
      <Dropdown.Toggle variant="default" className="icon-btn md-btn-flat mr-3">
        <i className="ion ion-ios-more"></i>
      </Dropdown.Toggle>
      <Dropdown.Menu>{renderItems()}</Dropdown.Menu>
    </Dropdown>
  );
};
